module.exports = __webpack_public_path__ + "static/role-of-it-bf887a851774bd40ac16624b8ed45d2e.jpg";